// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ppIi","label":"styles_label__Ec4_5"};